import { combineReducers } from 'redux';
import { createReduceObject as createReqStatusReduceObject } from '../../../../common/reducers/_requestStatus/reducer';
import { createReduceObject as createErrorsFormReduceObject } from '../../../../common/reducers/_formErrors/reducer';
import { createReduceObject as createFormReduceObject } from './reducer';
import createSaga from './saga';
import { reducerRegistry } from '../../../../reducerRegistry';

// eslint-disable-next-line import/prefer-default-export
export function registryCombineReducer(reducerName) {
  const combine = combineReducers({
    ...createReqStatusReduceObject(reducerName),
    ...createFormReduceObject(reducerName),
    ...createErrorsFormReduceObject(reducerName)
  });
  reducerRegistry.register(reducerName, combine, createSaga);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/combineRegistry.js